import { Roarr } from 'roarr';

export const Logger = Roarr.child({
  package: 'slonik',
});
